import React, { useState } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import ExtraTab from "../../HomeSettingPage/ExtraTab";

const Step5ExtraPrograms = ({
  wizardData,
  setWizardData,
  registrationID,
  settingInfo,
}) => {
  const [groupList, setGroupList] = useState([]);

  return (
    <div className="wizard-step-card">
      <h3 className="wizard-step-title">Extra Programs</h3>
      <p className="wizard-step-description">
        Add optional extra programs or add-ons that participants can purchase
        during registration.
      </p>

      <div className="wizard-info-box" style={{ marginBottom: 24 }}>
        <p>
          <InfoCircleOutlined style={{ marginRight: 8 }} />
          This step is optional for the wizard. You can skip it now and add extra
          programs later using the "Extra Programs" tab in manual mode.
        </p>
      </div>

      {/* Embed the ExtraTab component */}
      <ExtraTab
        groupList={groupList}
        setGroupList={setGroupList}
        registrationID={registrationID}
        setRegistrationID={() => {}}
        settingInfo={settingInfo}
        hideActionButtons={false}
      />
    </div>
  );
};

export default Step5ExtraPrograms;
